import React, { useEffect } from "react";
import "./UserProfileModal.css";
import { FiX, FiUser, FiMail, FiBriefcase, FiPhone, FiCreditCard } from "react-icons/fi";

const UserProfileModal = ({ user, isOpen, onClose }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };
    window.addEventListener("keydown", handleEscape);
    return () => window.removeEventListener("keydown", handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen || !user) return null;

  const roleColors = {
    CLIENT: "rgba(74, 144, 226, 0.1)",
    ANALYST: "rgba(16, 185, 129, 0.1)",
    ADMIN: "rgba(245, 158, 11, 0.1)",
  };

  const roleBorderColors = {
    CLIENT: "rgba(74, 144, 226, 0.5)",
    ANALYST: "rgba(16, 185, 129, 0.5)",
    ADMIN: "rgba(245, 158, 11, 0.5)",
  };

  const roleTextColors = {
    CLIENT: "#4a90e2",
    ANALYST: "#10b981",
    ADMIN: "#f59e0b",
  };

  return (
    <div className="user-profile-overlay" onClick={onClose}>
      <div className="user-profile-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose} aria-label="Close">
          <FiX size={24} />
        </button>

        <div className="profile-header">
          <div className="profile-avatar">
            {(
              user.first_name?.charAt(0) ||
              user.name?.charAt(0) ||
              "U"
            ).toUpperCase()}
          </div>
          <h2 className="profile-name">
            {user.first_name && user.last_name
              ? `${user.first_name} ${user.last_name}`
              : user.name || "User"}
          </h2>
          <div
            className="profile-role"
            style={{
              backgroundColor:
                roleColors[user.role] || "rgba(33, 37, 41, 0.15)",
              borderColor:
                roleBorderColors[user.role] || "rgba(33, 37, 41, 0.3)",
              color: roleTextColors[user.role] || "var(--text-dark)",
            }}
          >
            {user.role}
          </div>
        </div>

        <div className="profile-content">
          <div className="profile-field">
            <div className="field-icon">
              <FiMail size={18} />
            </div>
            <div className="field-content">
              <div className="field-label">Email</div>
              <div className="field-value">{user.email}</div>
            </div>
          </div>

          {user.organization_name && (
            <div className="profile-field">
              <div className="field-icon">
                <FiBriefcase size={18} />
              </div>
              <div className="field-content">
                <div className="field-label">Organization</div>
                <div className="field-value">{user.organization_name}</div>
              </div>
            </div>
          )}

          {user.role === "ANALYST" && (user.identification_id || user.phone) && (
            <>
              {user.identification_id && (
                <div className="profile-field">
                  <div className="field-icon">
                    <FiCreditCard size={18} />
                  </div>
                  <div className="field-content">
                    <div className="field-label">Identification ID (Rwandan)</div>
                    <div className="field-value">{user.identification_id}</div>
                  </div>
                </div>
              )}
              {user.phone && (
                <div className="profile-field">
                  <div className="field-icon">
                    <FiPhone size={18} />
                  </div>
                  <div className="field-content">
                    <div className="field-label">Phone (Rwandan)</div>
                    <div className="field-value">{user.phone}</div>
                  </div>
                </div>
              )}
            </>
          )}

          <div className="profile-field">
            <div className="field-icon">
              <FiUser size={18} />
            </div>
            <div className="field-content">
              <div className="field-label">Account Status</div>
              <div className="field-value">
                <span
                  className="status-badge"
                  style={{
                    backgroundColor: user.is_active
                      ? "rgba(16, 185, 129, 0.1)"
                      : "rgba(239, 68, 68, 0.1)",
                    color: user.is_active ? "#10b981" : "#ef4444",
                  }}
                >
                  {user.is_active ? "Active" : "Pending"}
                </span>
              </div>
            </div>
          </div>

          {user.date_joined && (
            <div className="profile-field">
              <div className="field-icon">
                <FiBriefcase size={18} />
              </div>
              <div className="field-content">
                <div className="field-label">Joined</div>
                <div className="field-value">
                  {new Date(user.date_joined).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="profile-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserProfileModal;
